import InsuredPerson from './InsuredPerson';

export default InsuredPerson;
